//=include _respond.min.js
//=include _jquery-1.11.0.min.js
//=include _jquery.easing.min.js
//=include _jquery.easing.compatibility.js
//=include _jquery.fs.shifter.min.js
//=include _jquery.resize.min.js
//=include _wow.min.js
//=include _lazyload.min.js
//=include _framework.js
//=include _general.js
